import apiClient from '../api.js';

// Capa de servicios para el CRUD de notas de estudiante (`unicen.nota`).
//
// Contrato asumido (backend en capas, `modules/academico`):
// las respuestas de error de estos endpoints exponen el mensaje vía
// `.mensaje` (a diferencia de los endpoints legacy `/estudiante/...`, que
// usan `.message`) — ver `manejar-error.js` del módulo académico.
//
//   GET    /academico/notas?unicodigo=&id_sede=
//          -> { data: [{ id_nota, unicodigo, id_plan_estudio, id_materia,
//                         id_sede, id_gestion, id_grupo, paralelo, pp, sp,
//                         tp, ef, ast, si, ma, gr, nf, estnota, obs,
//                         id_usuario, nombre_materia, cod_materia, ... }] }
//          (solo notas con est='ACTIVO')
//
//   GET    /academico/notas/materias-disponibles?unicodigo=&id_sede=
//          -> { data: [{ id_plan_materia, id_materia, nombre_materia,
//                         cod_materia, creditos }] }
//          OJO: NO incluye `id_plan_estudio` por fila (es el mismo para
//          todas: el de la última inscripción resuelta en el backend). Si
//          se necesita persistirlo en el alta, hay que resolverlo aparte.
//
//   POST   /academico/notas
//          body: { unicodigo, id_plan_estudio, id_materia, id_sede,
//                  id_gestion, id_grupo, paralelo, pp, sp, tp, ef, ast, si,
//                  ma, gr, obs, id_usuario }
//          -> { data: <fila creada>, mensaje }
//          `nf`/`nfr` se calculan y sobreescriben SIEMPRE en el backend a
//          partir de pp/sp/ef (y si/ma para `nf`), EXCEPTO si el body manda
//          `nf` y/o `nfr` explícitamente: eso solo se respeta si la nota no
//          tiene pp/sp/tp/ef/si/ma cargados (400/409
//          `EdicionNfNoPermitidaError` si ya hay algo cargado). `estnota`
//          siempre sale de `nf`, nunca del cliente.
//
//   PUT    /academico/notas/:id
//          body: PATCH real — solo hace falta mandar las claves que cambian
//                (de { pp, sp, tp, ef, ast, si, ma, gr, obs, paralelo,
//                id_grupo, id_gestion }); lo que no se manda queda como
//                estaba en la nota, el backend NO lo pisa con null/0.
//          -> { data: <fila actualizada>, mensaje }
//          `nf`/`nfr`/`estnota` se recalculan en el backend a partir de la
//          fila ya fusionada, EXCEPTO si el body manda `nf` y/o `nfr`
//          explícitamente: eso está permitido solo cuando la nota no tiene
//          pp/sp/tp/ef/si/ma cargados (400/409 `EdicionNfNoPermitidaError`
//          si ya hay algo cargado).
//
//   DELETE /academico/notas/:id
//          -> { data: <fila con est='INACTIVO'>, mensaje }  (baja lógica)

const resource = '/academico/notas';

const useEstudianteNotasApi = {
  listar(unicodigo, idSede) {
    return apiClient.get(resource, { params: { unicodigo, id_sede: idSede } });
  },

  listarMateriasDisponibles(unicodigo, idSede) {
    return apiClient.get(`${resource}/materias-disponibles`, { params: { unicodigo, id_sede: idSede } });
  },

  crear(datos) {
    return apiClient.post(resource, datos);
  },

  actualizar(idNota, datos) {
    return apiClient.put(`${resource}/${idNota}`, datos);
  },

  eliminar(idNota) {
    return apiClient.delete(`${resource}/${idNota}`);
  },
};

export default useEstudianteNotasApi;
